import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import ContentBox from "../../../../../components/content-box/ContentBox";
import DonationTracker from "../../../../../components/donation-tracker/DonationTracker";
import DonationInfo from "../../../../../model/DonationInfo";
import PageActions from "../../../../base/PageActions";
import useFetchResult from "../../../../../hooks/UseFetchResult";
import _http_service from "../../../../../services/HttpService";
import _image_service from "../../../../../services/ImageService";
import "../../../../styles/Common.scss";
import "../CharityStreamPage.scss";

interface GoCharityStreamPageProps {
}

interface Event {
    fullName: string,
    shortName: string,
    year: number
}

const GoCharityStreamPage = (props: GoCharityStreamPageProps) => {

    const _events: Event[] = [
        {fullName: "Vtuber Summer Slam 2026", shortName: "vss", year: 2026},
        {fullName: "Vtuber Summer Slam 2025", shortName: "go", year: 2025},
        {fullName: "Jolly Jamboree 2024", shortName: "jj", year: 2024},
        {fullName: "Vtuber Summer Slam 2024", shortName: "go", year: 2024},
        {fullName: "Vtuber Summer Slam 2023", shortName: "go", year: 2023}
    ];

    const page: PageActions = new PageActions({
        title: `Charities: Gamers Outreach - Chase the Fox`,
        description: `Learn more about Chase's efforts to help hospital-bound children!`,
        keywords: ["twitch", "stream info", "chasetheredfox", "charity", "gamers outreach"],
        imgSrc: `chase/assets/chase_twitch_icon.png`,
        url: `stream/charities/go`
    });

    const [event, setEvent] = useState<Event>(_events[0]);

    const navigateTo = useNavigate();

    const [getResult, hasFetchedResult, setFetchedResult] = useFetchResult<DonationInfo>(undefined,
        async () => _http_service.getDonations(event.shortName, ""+event.year)
            .then(response => {
                if (!response) {
                    throw new Error("Could not fetch donation data!");
                }

                return response;
            }), [event]);

    const changeEvent = (event: String): void => {
        setEvent(_events.find(e => e.fullName === event) || _events[0]);
        setFetchedResult(false);
    };

    return page.generateMetaContent(
        <>
            <ContentBox className="donations-content-height"
                        header="Putting smiles on the faces of those who need them most!">
                <div>
                    <img src={_image_service.getCdnImageSrc('chase/stream/charities/go_screen_cap.png')}
                         alt="Chase helping raise money for Gamers Outreach during one of his streams."
                         title="Let's GO, Fox Fam!"
                         className="width-50-percent block"/>
                    <p>
                        It's proven that ill children have a better quality of life and recover faster when they
                        are having fun. That is the mantra of Gamers Outreach. This great charity raises money to
                        provide children in hospitals with gaming equipment and experiences that aid their recovery.
                        They are a successful and well-organized charity, and I am happy to have partnered with
                        them!
                    </p>
                    <p>
                        I first participated in the <strong>Vtuber Summer Slam</strong> in 2023, and since then I've
                        worked with plenty of other gamers on various streaming platforms. I've been invited to more
                        Gamers Outreach events as I continue to build a relationship with the charity, and the support
                        from the Fox Fam continues to grow. Together, those of us giving our time for the cause have
                        been able to raise hundreds of thousands of dollars toward this effort!
                    </p>
                    <p>
                    Please consider <a href="https://gamersoutreach.org/donate/"
                                           target="_blank"
                                           rel="noopener noreferrer">
                            donating to Gamers Outreach
                        </a> to help us bring smiles to the faces of kids who need them.
                    </p>
                    <div style={{margin: "0 auto 16px", width: "fit-content"}}>
                        <label htmlFor="go-year-select">Select an event:</label>
                        <select name="go-year-select"
                                onChange={e => changeEvent(e.target.value)}>
                            {_events.map(ev => <option key={`donation-tracker-option-${ev.shortName}-${ev.year}`}
                                                              defaultValue={ev.fullName}
                                                              value={ev.fullName}>{ev.fullName}</option>)}
                        </select>
                    </div>
                    {hasFetchedResult &&
                        <DonationTracker key={`donation-tracker-go-${Object.keys(getResult()).length}`}
                                         cause={event.fullName}
                                         donations={getResult()}/>
                    }
                </div>
            </ContentBox>
        </>
    );
}

export default GoCharityStreamPage;